// style
import './app.css'

// pages
import Home from './pages/Home';

function App() {
 
  return (
  
    <div className='app'>
       <Home/>
    </div>
 
  );
}

export default App;
